export default {
  // general

  // errors
  ERROR_GETTING_EARNINGS_HISTORY: "There was an error retrieving earnings information",
  ERROR_GETTING_MONTHLY_BREAKDOWN_12_MOS:
    "There was an error retrieving monthly earnings breakdown for the last 12 months",
  ERROR_GETTING_MONTHLY_BREAKDOWN: "There was an error retrieving monthly earnings breakdown",
};
